export default {
  zh: {
    getNow:'立即获取',
    servers: '服务器覆盖全球',
    lighteningSpeed: '无限的流量，极致的速度',
    everyCorner: '让您连接到世界任何角落。',
    noNeedSetting: '一键操作，无需设置',
    noTerminology: '抛开复杂的网络设置，难懂的专业术语。',
    clickContact: '您只需要打开软件，按下连接！开始你的全球大冒险。',
    noBandwidthCharge: '千兆加速，无限流量',
    breakBandwidth: '突破带宽，稳定加速',
    advancedTechnique: '用先进的加速技术，甚至可以突破运营商的带宽限制。在我们的带宽测试中，下载速度超过了1000Mb/s，连接延迟仅有几十毫秒。而且 Plex加速器 没有流量限制！',
    download: '下载',
    dataEncryption: '数据加密',
    respectPrivacy: '尊重隐私，保护您的个人信息',
    encryptInfo: '您访问网站的流量将会被 Plex加速器 加密，任何人都无法查看您发送的信息。当你使用 Plex 加速器 连接互联网时，我们将会隐藏你的 IP 地址，任何人都无法追踪您的位置。',
    compatibility: '设备兼容，一应俱全',
    compatibilityInfo: '不管操作系统是 Android、iOS、Window、MacOS、Ubuntu 还是 Android TV，Plex 加速器 都拥有操作简便的客户端。VIP 可享受手机，平板，电脑跨平台使用！',
    visitglobal:'不受限制地访问全球内容',
    visitcontent1:'无论您身在何处，连接 Plex加速器 后都能解锁全球的网站及应用程序，您可以畅玩有地域限制的游戏，安全而快速地访问完整的 Netflix，Hulu，BBC 等流媒体平台。',
    visitcontent2:'打开 Plex加速器，按下连接按钮，享受我们的闪电冲浪速度，连接世界',
    privacyprotection:'保护您的信息安全',
    privacycontent1:'Plex加速器 保护使用者的隐私不被泄露；当你使用 Plex加速器 连接互联网时，我们将会隐藏你的 IP 地址，任何人都无法追踪您的位置。',
    privacycontent2:'打开 Plex加速器，按下连接按钮，享受我们的闪电冲浪速度，连接世界',
    advantage1:'操作简单',
    advantage2:'享受高速网络',
    advantage3:'无日志',
    advantagecontent1:'仅需轻轻一点，即可加密您的网络，与世界相连。',
    advantagecontent2:'超快专线，告别所有的缓冲与卡顿。',
    advantagecontent3:'Plex加速器 不保存任何用户日志，确保您的隐私绝对安全。',
    globalNote:'全球超多节点',
    multipleDevices:'支持多种设备',
    advantagecontent:'Plex加速器 在全球拥有超多线路，支持38个国家，55个地区，数以千计的 VPN 服务器可确保您的网络连接不受影响。加载网站、下载文件、观看视频，开启 Plex加速器 即可享受超快的互联网连接。',
    multipleDevicesContent:'您想要自己的隐私在所有设备上都享受保护？不管您在使用 Android、iOS、Window、MacOS、Ubuntu 还是 Android TV，Plex加速器 都能提供好用而轻便的客户端，全方位为您提供优质的服务。',
    evaluate:'用户评价',
    userName1:'yy dd',
    userEvaluate1:'速度快，确实快，稳定，且不怎么影响不用梯子的软件',
    userName2:'鹏哥',
    userEvaluate2:'性价比比较高，速度比较稳定。',
    userName3:'HongJie Luo',
    userEvaluate3:'不是好，是最好！',
    userName4:'王伯宇',
    userEvaluate4:'很好的体验',
    userName5:'牵牛花的方向',
    userEvaluate5:'这是我用过最好用的VPN了，开发者也十分耐心的给每个评论回复，连续用了几年了，希望这软件越来越好。',
    userName6:'吴锦涛',
    userEvaluate6:'从买了到现在一直都很快，一直都挺快的，没出现过评论说的网速慢，慢了换节点就好了，希望这个软件能越来越好，能推出更加优惠的套餐，加油(ง •̀_•́)ง！',
    userName7:'YUNQI LAI',
    userEvaluate7:'网速很快，看网飞毫无压力。客服的态度和回复速度也是一流。强烈推荐！希望稳重求进，更上一层。',
  },

  en: {
    getNow:'Get Now',
    servers: 'Superfast servers all over the world',
    lighteningSpeed: 'Unlimited traffic and lightning speed enable you connect every corner of the world.',
    everyCorner: ' ',
    noNeedSetting: 'One click connection, do not need to set up',
    noTerminology: 'Ignore complicated network settings and terminology ',
    clickContact: 'Open PlexVPN, press the connect button, and enjoy our lightening surfing speed, connect to the world',
    noBandwidthCharge: 'No bandwidth charges or speed limits',
    breakBandwidth: 'Breakthrough bandwidth, speed stability',
    advancedTechnique: 'With the advanced acceleration technology, users even can break through the bandwidth limit of carriers. Through our test, the download speed exceeds 1000Mb/s with connection latency of just a few tens of milliseconds. The best part is that PlexVPN doesn’t have traffic limit.',
    download: 'Download',
    dataEncryption: 'Data encryption',
    respectPrivacy: 'We respect your privacy and protect your personal information.',
    encryptInfo: 'The traffic you send to the site will be encrypted by PlexVPN and no one will be able to view the information you send. When you use PlexVPN to connect to the Internet, we will hide your IP address and no one will be able to track your location.',
    compatibility: 'Compatibility',
    compatibilityInfo: 'PlexVPN has user-friendly clients for Android, iOS, MacOS, Ubuntu and Andorid TV devices. VIP members can enjoy the cross-platform use of mobile phones, tablets and computers.',
    visitglobal:'Bypass Geo-blocking and Get Global Content',
    visitcontent1:'Unblock global websites and apps with PlexVPN wherever you are. You can stream Netflix, Hulu, BBC and other streaming sites securely and quickly, and enjoy geo-restricted games. ',
    visitcontent2:'Open PlexVPN, press the connect button, and enjoy our lightening surfing speed, connect to the world',
    privacyprotection:'Protect Your Private Information',
    privacycontent1:'PlexVPN protects users\' privacy from being leaked. When you use PlexVPN, we will hide your real IP address, and no one can track your location.',
    privacycontent2:'Open PlexVPN, press the connect button, and enjoy our lightening surfing speed, connect to the world',
    advantage1:'Easy to Use',
    advantage2:'Enjoy Fast Speed',
    advantage3:'No Logs',
    evaluate:'Reviews by Our Users',
    advantagecontent1:'All you need is a single click, and you can secure your online traffic and connect the world.',
    advantagecontent2:'No more buffering and lagging with our blazing fast dedicated servers.',
    advantagecontent3:'PlexVPN does not store any user log, which guarantees that you can stay private from everyone, even us. ',
    globalNote:'High-speed servers worldwide',
    advantagecontent:'PlexVPN has a huge range of servers around the world, supporting 38 countries and 55 regions. Thousands of servers ensure that your Internet performance is not slowed down. Your browsing, downloading, streaming will be lightning fast through PlexVPN’s huge network.',
    multipleDevices:'Support a Wide Range of Devices',
    multipleDevicesContent:'Want privacy on all devices? PlexVPN offers user-friendly clients for Android, iOS, macOS, Ubuntu and Android TV devices. Your data is safe with PlexVPN across all apps and platforms.',
    userName1:'dlwlrma',
    userEvaluate1:'Best app quick to connect and fast server',
    userName2:'okot bruno',
    userEvaluate2:'This app is great it doesn\'t bring ads and it connects very fast',
    userName3:'Garikayi Mhizha',
    userEvaluate3:'This is an excellent app. It has the best servers, best customer service and surely the best reasonable prices for the great service they provide.',
    userName4:'MH Kam',
    userEvaluate4:'Excellent connectivity, the best I have ever experienced.',
    userName5:'Kenneth Mugwanya',
    userEvaluate5:'Supper fast connection Speed VPN I liked it in the first installation. 5/5 stars. Highly recommended. Thanks developer Team.',
    userName6:'마르티네즈남자 이름',
    userEvaluate6:'It Auto-Connected very quickly, It had a stable connection throughout. Love it, would recommend to some.',
    userName7:'Jesse Elizondo',
    userEvaluate7:'The Plex VPN works consistently well and is one of my favs.',
  }
}



// WEBPACK FOOTER //
// ./src/views/home/homeBodyPhone/lang.js